import React, { useState, useEffect, createContext } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
// components
import Loader from '../components/Loader';
// services
import { getEvent } from '../services/Event';

export const EventContext = createContext();

EventProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default function EventProvider({ children }) {
  const [searchParams] = useSearchParams();
  const [event, setEvent] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async (eventId) => {
      try {
        const event = await getEvent(eventId);
        setEvent(event);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        alert('An error occurred! Please, refresh the page and try again.');
      }
    };

    const eventId = searchParams.get('eventId');
    if (eventId) {
      fetchData(eventId);
    } else {
      setEvent(undefined);
      setIsLoading(false);
    }
  }, [searchParams]);

  if (isLoading) {
    return <Loader align="center" />;
  }

  return (
    <EventContext.Provider value={{ event, setEvent }}>
      {!isLoading && children}
    </EventContext.Provider>
  );
}
